import React from 'react'
import { fs } from '../controls/Constants'

const Footer = () => {
    const now = new Date()
    const year = now.getFullYear()
    return (
    <footer>
        <p className={fs}>&copy; {year} Kari Arduino Library. All rights reserved.</p>  
    </footer>
    )
}

export default Footer
